import { ReactNode, useMemo } from "react";
import { Teacher } from "../../models/teacher/teacher";
import { Avatar } from "../Avatar";
import { Content } from "../Content";
import Card, { CardProps } from "../ui-lib/Card";
import React from "react";
import { WithChildren } from "../../helpers/constants/types";
import classNames from "classnames";

type GenericTeacherCardProps = {
  teacher: Teacher;
  children?: ReactNode;
  avatarClass?: string;
} & CardProps;

function GenericTeacherCard({
  teacher,
  children,
  className,
  avatarClass,
  ...props
}: GenericTeacherCardProps) {
  const contentElement = useMemo(
    () =>
      React.Children.toArray(children).filter(
        (child) => React.isValidElement(child) && child.type === Content,
      )[0],
    [children],
  );

  const actionElements = useMemo(
    () =>
      React.Children.toArray(children).filter(
        (child) => React.isValidElement(child) && child.type === Action,
      ),
    [children],
  );

  return (
    <Card className={classNames("justify-between", className)} {...props}>
      <div className="flex items-center space-x-2">
        <Avatar
          avatar={teacher}
          className={classNames(
            !avatarClass &&
              (teacher.internal ? "bg-th-primary-900" : "bg-th-accent-900"),
            avatarClass,
          )}
        ></Avatar>
        <div className="flex flex-col leading-none">
          {contentElement ? (
            contentElement
          ) : (
            <>
              <span
                className={classNames(
                  "text-xs font-bold",
                  teacher.internal
                    ? "text-th-primary-900"
                    : "text-th-accent-900",
                )}
              >
                {teacher.internal ? "Intern" : "Extern"}
              </span>
              <span className="font-bold">{teacher.fullName}</span>
            </>
          )}
        </div>
      </div>
      <div className="ml-4 flex space-x-2 self-center">{actionElements}</div>
    </Card>
  );
}

const Action: React.FC<WithChildren> = ({ children }) => {
  return <>{children}</>;
};

GenericTeacherCard.Content = Content;
GenericTeacherCard.Action = Action;

export default GenericTeacherCard;
